import { render } from "./pointListNew.vue?vue&type=template&id=18a7511f&scoped=true"
import script from "./pointListNew.vue?vue&type=script&lang=js"
export * from "./pointListNew.vue?vue&type=script&lang=js"

import "./pointListNew.vue?vue&type=style&index=0&id=18a7511f&scoped=true&lang=css"

import exportComponent from "/Users/cole/.codex/worktrees/jwt-cookie-expiry/tcd-cube_opr/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18a7511f"]])

export default __exports__